export default function (targetElement, top = true, yOffset = 10) {
  window.scrollTo({
    top:
      targetElement.getBoundingClientRect()[top ? 'top' : 'bottom'] +
      window.pageYOffset +
      yOffset,
    behavior: 'smooth'
  })
}
